export default "__VITE_PUBLIC_ASSET__ef632499__"